import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import Header from '../Component/Header';
import Footer from '../Component/Footer';
const Staff = () => {
  useEffect(() => {
    document.title = 'Staff -  St Peters convent School Faridabad Haryana';
  }, []);
  return (
    <>
      <Header />
      <div className="video-background">
      <video autoPlay muted loop playsinline>
           <source src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/staff.mp4" type="video/mp4"/>
    </video>
       { /*    <ul className="breadcrumb">
          <li><Link to="/"> Home</Link> </li>
          <li>  About Us  </li>
          <li> Staff </li>
        </ul> */}
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1> Staff </h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <nav>
                <div class="nav nav-tabs" id="nav-tab" role="tablist">
                  <button class="nav-link active" id="teachingstaff-tab" data-bs-toggle="tab" data-bs-target="#teachingstaff" type="button" role="tab" aria-controls="teachingstaff" aria-selected="true">Teaching Staff
                  </button>
                  <button class="nav-link" id="officestaff-tab" data-bs-toggle="tab" data-bs-target="#officestaff" type="button" role="tab" aria-controls="officestaff" aria-selected="false">Office Staff</button>
                  <button class="nav-link" id="nonteaching-tab" data-bs-toggle="tab" data-bs-target="#nonteaching" type="button" role="tab" aria-controls="nonteaching" aria-selected="false">Non Teaching Staff</button>
                </div>
              </nav>
              <div class="tab-content" id="nav-tabContent">

                <div class="tab-pane fade show active" id="teachingstaff" role="tabpanel" aria-labelledby="teachingstaff-tab">
                  <div class="table-responsive maintable">
                    <table class="table">
                      <thead>
                        <tr>
                          <th>S.No.</th>
                          <th>Name of the Teacher</th>
                          <th>Qualification</th>
                          <th>Designation</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr><td>1</td><td>Sr RUBY GEORGE</td><td>PRINCIPAL</td><td>MSc, B Ed, PhD</td></tr>
                        <tr><td>2</td><td>HEMA NEGI</td><td>NTT</td><td>M COM, B Ed, NTT</td></tr>
                        <tr><td>3</td><td>NAMISHA NAULAY</td><td>NTT</td><td>BA (Sociology), NTT</td></tr>
                        <tr><td>4</td><td>ARTI TANEJA</td><td>NTT</td><td>ETT, NTT, MA (English/ Hindi), B Ed</td></tr>
                        <tr><td>5</td><td>RENU</td><td>NTT</td><td>MSc (IT), NTT</td></tr>
                        <tr><td>6</td><td>RANJANA TIWARI</td><td>NTT</td><td>MA (History), BEd</td></tr>
                        <tr><td>7</td><td>SWATI VERMA</td><td>NTT</td><td>BCom, NTT</td></tr>
                        <tr><td>8</td><td>BHAWANA SHARMA</td><td>NTT</td><td>B Com, NTT, BEd</td></tr>
                        <tr><td>9</td><td>KAVITA BALAKRISHNAN PILLAI</td><td>NTT</td><td>BA (Social Science), PTT</td></tr>
                        <tr><td>10</td><td>SURBHI AHUJA ADLAKHA</td><td>NTT</td><td>NTT</td></tr>
                        <tr><td>11</td><td>SHEFALI DYO</td><td>NTT</td><td>MA (English), DEL Ed</td></tr>
                        <tr><td>12</td><td>KOMAL MADAN</td><td>PRT</td><td>MCom, B Ed</td></tr>
                        <tr><td>13</td><td>KANIKA SATIA</td><td>PRT</td><td>NTT, BSc (Fashion Designing and Management), B Ed</td></tr>
                        <tr><td>14</td><td>SUNITA PALIWAL</td><td>PRT</td><td>MA (English), B Ed</td></tr>
                        <tr><td>15</td><td>AKANKSHA CHAUHAN</td><td>PRT</td><td>B Sc (Honours Botany), B Ed</td></tr>
                        <tr><td>16</td><td>VINEETA RAZDAN</td><td>PRT</td><td>M Sc (Physics), B Ed</td></tr>
                        <tr><td>17</td><td>MEENAKSHI BENJAMIN</td><td>PRT</td><td>BEd, MBA</td></tr>
                        <tr><td>18</td><td>DEEPANSHI GUPTA</td><td>PRT</td><td>BA ENGLISH (Hons), B.Ed, CTET</td></tr>
                        <tr><td>19</td><td>KASHISH CHUGH</td><td>PRT</td><td>BSc (Hons. Botany), MSc (Botany), B Ed</td></tr>
                        <tr><td>20</td><td>NISHI SHARMA</td><td>PRT</td><td>MA (History), B Ed</td></tr>
                        <tr><td>21</td><td>REKHA TYAGI</td><td>PRT</td><td>BA (Sociology), B LIB, M LIB, BEd</td></tr>
                        <tr><td>22</td><td>PREETI MISHRA</td><td>PRT</td><td>MA (Hindi), B Ed</td></tr>
                        <tr><td>23</td><td>RENU SINGH</td><td>PRT</td><td>MA (Sociology), BEd</td></tr>
                        <tr><td>24</td><td>ANJALI</td><td>PRT</td><td>BA, MA (English), B Ed</td></tr>
                        <tr><td>25</td><td>REKHA DUA</td><td>PRT</td><td>BSc, MCA, BEd, MTech</td></tr>
                        <tr><td>26</td><td>SUSHMA RANI</td><td>PRT</td><td>MA (Sanskrit), BEd</td></tr>
                        <tr><td>27</td><td>MONALI KUNDU</td><td>PRT</td><td>M.Sc (Mathematics), B.Ed</td></tr>
                        <tr><td>28</td><td>SUMAN NARWAT</td><td>PRT</td><td>BA (Geography Honours), B Ed</td></tr>
                        <tr><td>29</td><td>BHAVYA CHOPRA</td><td>PRT</td><td>BA (English), MA (English), B Ed</td></tr>
                        <tr><td>30</td><td>RAKHI</td><td>PRT</td><td>BSc (Maths), MSc (Maths), B Ed</td></tr>
                        <tr><td>31</td><td>UPASANA SINGH</td><td>PRT</td><td>B Ed, MA (English)</td></tr>
                        <tr><td>32</td><td>ASMITA CHAWLA</td><td>PRT</td><td>BA (English), B Ed</td></tr>
                        <tr><td>33</td><td>RUCHI SINGH</td><td>PRT</td><td>BSc (Math), MSc (Math), B.Ed, CTET</td></tr>
                        <tr><td>34</td><td>SHEETAL VERMA</td><td>PRT</td><td>MA (Geography), MA (Education), M.Lib, B.Ed</td></tr>
                        <tr><td>35</td><td>MANSI</td><td>PRT</td><td>BA (Arts & Commerce), B.Ed</td></tr>
                        <tr><td>36</td><td>PRIYANKA ROHILLA</td><td>PRT</td><td>M.Sc, B.Ed, HTET, CTET, GATE</td></tr>
                        <tr><td>37</td><td>ANGELEEN JOHN</td><td>PRT</td><td>MSc (Chemistry), B.Ed (Pursuing)</td></tr>
                        <tr><td>38</td><td>BETINA PULINILKUNNATHIL VARGHESE</td><td>PRT</td><td>BA, B.Ed, MA (English)</td></tr>
                        <tr><td>39</td><td>JYOTHI RAMACHANDRAN</td><td>PRT</td><td>BSc (Hons Physics), MA (Rural Development), BEd</td></tr>
                        <tr><td>40</td><td>SWATI AGGARWAL</td><td>PRT</td><td>MA (History), B Ed</td></tr>
                        <tr><td>41</td><td>TANUSREE BISWAS</td><td>PRT</td><td>BSc (Hons Chemistry), MSc (Food & Nutrition), B Ed</td></tr>
                        <tr><td>42</td><td>ANITA PANWAR</td><td>PRT</td><td>B Tech (Computer Science), B Ed</td></tr>
                        <tr><td>43</td><td>ANU</td><td>PRT</td><td>BA (General), B Ed</td></tr>
                        <tr><td>44</td><td>GAGANDEEP KAUR</td><td>PRT</td><td>B Com, MCom, B Ed</td></tr>
                        <tr><td>45</td><td>MEENAKSHI</td><td>PRT</td><td>BA (English, Hindi, Sanskrit Music), M Ed</td></tr>
                        <tr><td>46</td><td>NISHA SHARMA</td><td>PRT</td><td>BSc (Non-Medical), B Ed</td></tr>
                        <tr><td>47</td><td>RENU CHAUDHARY</td><td>PRT</td><td>BA (Programme), B Ed</td></tr>
                        <tr><td>48</td><td>RATANPRIYA</td><td>PRT</td><td>M Com, B Ed</td></tr>
                        <tr><td>49</td><td>ANUSHKA KHOSLA</td><td>PRT</td><td>MA (Psychology), B Ed</td></tr>
                        <tr><td>50</td><td>APARNA CHATTERJEE</td><td>PRT</td><td>MA (Hindi), B Ed</td></tr>
                        <tr><td>51</td><td>SHASHI BALA</td><td>PRT</td><td>MSc (Computer Science), B Ed</td></tr>
                        <tr><td>52</td><td>MAMTA KUMARI PANTHA</td><td>PRT</td><td>MA (English), B Ed</td></tr>
                        <tr><td>53</td><td>SAVITA DEVI</td><td>PRT</td><td>BA (Sanskrit), MA (Pol. Science & Hindi), B Ed</td></tr>
                        <tr><td>54</td><td>JAI CHOPRA</td><td>PRT (PTI)</td><td>BCom, BPEd</td></tr>
                        <tr><td>55</td><td>YASODA SHARMA</td><td>PRT (PTI)</td><td>BCom, BPd</td></tr>
                        <tr><td>56</td><td>RISHIKA</td><td>PRT (PTI)</td><td>BA (General), B.PEd</td></tr>
                        <tr><td>57</td><td>AJAY KUMAR</td><td>PRT (PTI)</td><td>BA (Programme), B.PEd</td></tr>
                        <tr><td>58</td><td>SHYAM KUMAR</td><td>PRT (PTI)</td><td>BCom, MPED</td></tr>
                        <tr><td>59</td><td>PAROMITA MISRA</td><td>TGT</td><td>MSc, PGDCA, B Ed</td></tr>
                        <tr><td>60</td><td>HIMA BINDU DALAI</td><td>TGT</td><td>MA (English), BEd, CTET</td></tr>
                        <tr><td>61</td><td>SHAILA RAWAT</td><td>TGT</td><td>BSc, BEd, MA (Economics), NTT</td></tr>
                        <tr><td>62</td><td>KUSUM KATH</td><td>TGT</td><td>MA (Hindi), MEd</td></tr>
                        <tr><td>63</td><td>REKHA VERMA</td><td>TGT</td><td>MA (Sanskrit), BEd</td></tr>
                        <tr><td>64</td><td>RITIKA BHATIA</td><td>TGT</td><td>MSc (Mathematics), MEd</td></tr>
                        <tr><td>65</td><td>MAMTA PIPLANI</td><td>TGT</td><td>MA (Hindi), BEd</td></tr>
                        <tr><td>66</td><td>GUNJAN SHARMA</td><td>TGT</td><td>MSc (Physics), B Ed</td></tr>
                        <tr><td>67</td><td>JYOTI KALRA</td><td>TGT</td><td>MCA, B Ed</td></tr>
                        <tr><td>68</td><td>TANIA BHATTACHARYA</td><td>TGT</td><td>MSc (Chemistry), BEd</td></tr>
                        <tr><td>69</td><td>SURBHI MALHOTRA</td><td>TGT</td><td>ECCE, MA (Hindi), BEd, NTT</td></tr>
                        <tr><td>70</td><td>AMANDEEP</td><td>TGT</td><td>BEd, MPhil, MA (English)</td></tr>
                        <tr><td>71</td><td>KANIKA CHANDEL</td><td>TGT</td><td>MSc (Chemistry), B Ed</td></tr>
                        <tr><td>72</td><td>DISHA SINGH</td><td>TGT</td><td>BA (Hons. English), MA (English), B.Ed</td></tr>
                        <tr><td>73</td><td>PRIYANKA JAIN</td><td>TGT</td><td>BA (Eng, Sociology, Pol. Science), MA (Sociology, Education, English), NTT, B.Ed</td></tr>
                        <tr><td>74</td><td>SHRADHA ANJALI</td><td>TGT</td><td>MCom, BEd</td></tr>
                        <tr><td>75</td><td>POOJA SHARMA</td><td>TGT</td><td>BA, B Ed</td></tr>
                        <tr><td>76</td><td>MABEL VARGHESE</td><td>TGT</td><td>MSc, BEd, PhD (Micro Biology)</td></tr>
                        <tr><td>77</td><td>ANAMIKA BALI</td><td>TGT</td><td>MA (Pol. Science), BEd</td></tr>
                        <tr><td>78</td><td>PREETI DAGAR</td><td>TGT</td><td>MSc (Math), BEd, HTET (PRT & TGT), CTET (PRT), APS</td></tr>
                        <tr><td>79</td><td>PREETI CHUGH</td><td>TGT</td><td>MSc (Mathematics), B Ed</td></tr>
                        <tr><td>80</td><td>JYOTI SAINI</td><td>TGT</td><td>MSc (Computer Science), B Ed</td></tr>
                        <tr><td>81</td><td>PREETI SINGH</td><td>TGT</td><td>MA, MPhil (English), B Ed</td></tr>
                        <tr><td>82</td><td>REJIMOL JOSEPH</td><td>TGT</td><td>MA (History), B Ed</td></tr>
                        <tr><td>83</td><td>SHEEJA MATHEW</td><td>TGT</td><td>MA (English), B Ed</td></tr>
                        <tr><td>84</td><td>DEEPA CHAUHAN</td><td>TGT</td><td>MA (English), B Ed</td></tr>
                        <tr><td>85</td><td>BIMLESH</td><td>TGT (PTI)</td><td>BPEd, MA (Physical Education)</td></tr>
                        <tr><td>86</td><td>SUCHITA SHARMA</td><td>Special Educator</td><td>BA, Diploma in Special Education & Yoga, BEd</td></tr>
                        <tr><td>87</td><td>USHA</td><td>ART & CRAFT</td><td>BFA, Diploma in Art and Craft</td></tr>
                        <tr><td>88</td><td>ALKA MAHESHWARI</td><td>ART & CRAFT</td><td>BA (Hons Fine Arts), MA (Fine Arts)</td></tr>
                        <tr><td>89</td><td>MITASHA BHARDWAJ</td><td>Counselor</td><td>BSc (Hons Home Science), MSc (Psychology)</td></tr>
                        <tr><td>90</td><td>PRIYA AGARWAL</td><td>DANCE</td><td>BA, LLB (Pursuing), Kathak</td></tr>
                        <tr><td>91</td><td>AMARJEET KAUR</td><td>DANCE</td><td>BA (Mathematics), MA (Political Science), MA (Dance)</td></tr>
                        <tr><td>92</td><td>SUMAN MADAN</td><td>Librarian</td><td>BA (Psychology), BLIB</td></tr>
                        <tr><td>93</td><td>SWATI GAUTAM</td><td>Librarian</td><td>M Com, MLIB, BEd</td></tr>
                        <tr><td>94</td><td>SAUMYA PANDEY</td><td>MUSIC TEACHER</td><td>BA, Prabhakar (6th year), Prayag Sangeet Samiti</td></tr>
                        <tr><td>95</td><td>ASHISH KUMAR CHAUHAN</td><td>MUSIC TR.</td><td>BA (Music)</td></tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="tab-pane fade" id="officestaff" role="tabpanel" aria-labelledby="officestaff-tab">
                  <div class="table-responsive maintable">
                    <table class="table">
                      <thead>
                        <tr><th> Sl No </th><th> Employee Name </th><th> Designation </th></tr></thead>
                      <tbody>
                        <tr>
                          <td>1 </td>
                          <td>DENNY PAUL </td>
                          <td>ACCOUNTS </td>
                        </tr>
                        <tr><td>2 </td><td>RUCHIKA NARANG </td><td> ADMIN </td></tr>
                        <tr><td>3 </td><td>ARCHIT B CHERIAN </td><td> PRO </td></tr>
                        <tr><td>4 </td><td>JINIMOL SAJI </td><td> MEDICAL STAFF </td></tr>
                        <tr><td>5 </td><td>RUPALI SHARMA </td><td> ADMIN </td></tr>
                        <tr><td>6 </td><td>SHALINI FRANSISCA </td><td> FRONT OFFICE </td></tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="tab-pane fade" id="nonteaching" role="tabpanel" aria-labelledby="nonteaching-tab">
                  <div class="table-responsive maintable">
                    <table class="table">
                      <thead>
                        <tr>
                          <th> Sl No </th>
                          <th> Employee Name</th>
                          <th> Designation</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr><td>1</td><td>SHUBHAM</td><td>Gardener</td></tr>
                        <tr><td>2</td><td>GYAN CHAND</td><td>Conductor</td></tr>
                        <tr><td>3</td><td>ASHWANI KUMAR</td><td>Conductor</td></tr>
                        <tr><td>4</td><td>AMIT</td><td>Conductor</td></tr>
                        <tr><td>5</td><td>MANOJ KUMAR</td><td>Conductor</td></tr>
                        <tr><td>6</td><td>SANTOSH JHA</td><td>Conductor</td></tr>
                        <tr><td>7</td><td>RAVENDRA KUMAR</td><td>Conductor</td></tr>
                        <tr><td>8</td><td>RAHUL MASIH</td><td>Conductor</td></tr>
                        <tr><td>9</td><td>JOY MERCY</td><td>Conductor</td></tr>
                        <tr><td>10</td><td>ANITA CHAUHAN</td><td>Aaya</td></tr>
                        <tr><td>11</td><td>VIMLA DEVI</td><td>Aaya</td></tr>
                        <tr><td>12</td><td>POONAM</td><td>Aaya</td></tr>
                        <tr><td>13</td><td>BABLI</td><td>Aaya</td></tr>
                        <tr><td>14</td><td>MINA DEVI</td><td>Aaya</td></tr>
                        <tr><td>15</td><td>SINDHU DEVI</td><td>Aaya</td></tr>
                        <tr><td>16</td><td>KIRAN</td><td>Aaya</td></tr>
                        <tr><td>17</td><td>SUBHASH</td><td>Gardener</td></tr>
                        <tr><td>18</td><td>KULDEEP</td><td>Driver</td></tr>
                        <tr><td>19</td><td>PUSHPENDRA KUMAR</td><td>Driver</td></tr>
                        <tr><td>20</td><td>DHIRAJ KUMAR</td><td>Driver</td></tr>
                        <tr><td>21</td><td>SANDEEP SINGH</td><td>Driver</td></tr>
                        <tr><td>22</td><td>TARUN</td><td>Driver</td></tr>
                        <tr><td>23</td><td>SUNIL</td><td>Driver</td></tr>
                        <tr><td>24</td><td>SUNIL</td><td>Driver</td></tr>
                        <tr><td>25</td><td>PARVINDER SINGH</td><td>Driver</td></tr>
                        <tr><td>26</td><td>GEETA KUMARI</td><td>Aaya</td></tr>
                        <tr><td>27</td><td>USHA DEVI</td><td>Housekeeping</td></tr>
                        <tr><td>28</td><td>SAROJ</td><td>Housekeeping</td></tr>
                        <tr><td>29</td><td>RAKHI DEVI</td><td>Housekeeping</td></tr>
                        <tr><td>30</td><td>SAVITRI DEVI</td><td>Housekeeping</td></tr>
                        <tr><td>31</td><td>NEERAJ DEVI</td><td>Housekeeping</td></tr>
                        <tr><td>32</td><td>NISHA DEVI</td><td>Housekeeping</td></tr>
                        <tr><td>33</td><td>SHRAWANI KUMARI</td><td>Housekeeping</td></tr>
                        <tr><td>34</td><td>RACHNA</td><td>Housekeeping</td></tr>
                        <tr><td>35</td><td>POONAM SHRMA</td><td>Housekeeping</td></tr>
                        <tr><td>36</td><td>MANJU DEVI</td><td>Housekeeping</td></tr>
                        <tr><td>37</td><td>LAKKHI KUMARI</td><td>Housekeeping</td></tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default Staff
